import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  Box,
  Drawer,
  useMediaQuery,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SidebarWidth } from "../../../assets/global/Theme-variable";
import LogoIcon from "../Logo/LogoIcon";
import getMenuItems from "./data";
import TestData from "./TestData";
import { useStateContext } from "../../../context/ContextProvider";
import {jwtDecode} from "jwt-decode";
import LogoutIcon from '@mui/icons-material/Logout';
import Loader from "./Loader/Loader";

const Sidebar = (props) => {
  const Menuitems = getMenuItems();
  const MenuitemsTest = TestData ();
  const [open, setOpen] = useState({});
  const { pathname } = useLocation();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const navigate = useNavigate();
  const { setIsLoginUser, isLiveMode } = useStateContext();
  const [isLoading, setIsLoading] = useState(true);

  // Token validation
  useEffect(() => {
    const validateToken = () => {
      const token = sessionStorage.getItem("user");
      if (token) {
        try {
          const { exp } = jwtDecode(token);
          const expirationTime = exp * 1000; // Convert to milliseconds
          if (Date.now() >= expirationTime) {
            // Token expired
            sessionStorage.clear();
            setIsLoginUser(false);
            alert("Session expired. Please log in again.");
            navigate("/DepositPortal", { replace: true });
          }
        } catch (error) {
          console.error("Invalid token:", error);
          sessionStorage.clear();
          setIsLoginUser(false);
          alert("Session expired. Please log in again.");
          navigate("/DepositPortal", { replace: true });
        }
      } else {
        // No token found
        setIsLoginUser(false);
        alert("Session expired. Please log in again.");
        navigate("/DepositPortal", { replace: true });
      }
    };

    validateToken();
  }, [navigate, setIsLoginUser]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); 
    }, 1000); 
  
    return () => clearTimeout(timer);
  }, [props.modulePesmission]);

  const hasViewPermission = (moduleName) => {
    return props.modulePesmission?.some(
      (perm) => perm.module === moduleName && perm.m_view === 1
    );
  };

  let MenuitemsData;

  if (isLiveMode === "1") {
    MenuitemsData = Menuitems;
  } else {
    MenuitemsData = MenuitemsTest;
  }
  
  const filteredMenuItems = MenuitemsData.filter(item => {
    if (item.title === "Dashboard") return true;
    if (item.title === "Integration") return true;
    if (item.title === "Change Password") return true;
    if (item.moduleKey) {
      return hasViewPermission(item.moduleKey);
    }
    return true;
  });  
  

  const handleToggle = (index) => {
    setOpen((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const prevLiveMode = useRef(isLiveMode);

  // useEffect(() => {
  //   if (prevLiveMode.current !== isLiveMode) {
  //     if (Number(isLiveMode) === 1 && pathname !== "/DepositPortal/merchant_deposits") {
  //       navigate("/DepositPortal/merchant_deposits");
  //     } 
  //     else if (Number(isLiveMode) === 0 && pathname !== "/DepositPortal/merchant_test_deposits") {
  //       navigate("/DepositPortal/merchant_test_deposits");
  //     }
  //     prevLiveMode.current = isLiveMode;
  //   }
  // }, [isLiveMode, pathname, navigate]);

  // useEffect(() => {
  //   if (isLiveMode === "1") {
  //     navigate("/DepositPortal/merchant_deposits", { replace: true });
  //   } else {
  //     navigate("/DepositPortal/merchant_test_deposits", { replace: true });
  //   }
  // }, [isLiveMode]);


  useEffect(() => {
    // if (isLiveMode !== null) { 
      const liveUrl = "/DepositPortal/merchant_deposits";
      const testUrl = "/DepositPortal/merchant_test_deposits";

      if (prevLiveMode.current !== isLiveMode) {
        if (Number(isLiveMode) === 1 && pathname !== liveUrl) {
          navigate(liveUrl, { replace: true });
        } else if (Number(isLiveMode) === 0 && pathname !== testUrl) {
          navigate(testUrl, { replace: true });
        }
        prevLiveMode.current = isLiveMode;
      }
    // }
  }, [isLiveMode, pathname, navigate]);

  if (isLoading) {
    return (
      <Loader />
    );
  }

  const SidebarContent = (
    <Box sx={{ p: 3, height: "calc(100vh - 40px)" }}>
      <Link to="/">
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <LogoIcon />
        </Box>
      </Link>

      <Box>
        <List sx={{ mt: 4 }}>
          {filteredMenuItems.map((item, index) => (
            <React.Fragment key={item.title}>
              <ListItem
                button
                component={item.href ? NavLink : "div"}
                to={item.href || ""}
                onClick={() => item.children && handleToggle(index)}
                selected={pathname === item.href}
                sx={{
                  mb: 1,
                  ...(pathname === item.href && {
                    color: "white",
                    backgroundColor: (theme) =>
                      `${theme.palette.primary.main}!important`,
                  }),
                }}
              >
                <ListItemIcon
                  sx={{
                    ...(pathname === item.href && { color: "white" }),
                  }}
                >
                  <item.icon width="20" height="20" />
                </ListItemIcon>
                <ListItemText>{item.title}</ListItemText>
                {item.children && (
                  open[index] ? <ExpandLess /> : <ExpandMore />
                )}
              </ListItem>

              {item.children && (
                <Collapse in={open[index]} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding sx={{ pl: 4 }}>
                    {item.children.map((child) => (
                      <ListItem
                        key={child.title}
                        button
                        component={NavLink}
                        to={child.href}
                        selected={pathname === child.href}
                        sx={{
                          mb: 1,
                          ...(pathname === item.href && {
                            color: "white",
                            backgroundColor: (theme) =>
                              `${theme.palette.primary.main}!important`,
                          }),
                        }}
                      >
                        <ListItemText>{child.title}</ListItemText>
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          ))}
          <ListItem
            button
            onClick={() => {
              sessionStorage.clear();
              setIsLoginUser(false);
              navigate("/DepositPortal", { replace: true });
            }}
          >
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Box>
    </Box>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open={props.isSidebarOpen}
        variant="persistent"
        PaperProps={{
          sx: {
            width: SidebarWidth,
          },
        }}
      >
        {SidebarContent}
      </Drawer>
    );
  }
  return (
    <Drawer
      anchor="left"
      open={props.isMobileSidebarOpen}
      onClose={props.onSidebarClose}
      PaperProps={{
        sx: {
          width: SidebarWidth,
        },
      }}
      variant="temporary"
    >
      {SidebarContent}
    </Drawer>
  );
};

export default Sidebar;
